import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {ViewActionBarModel} from "../_models/ViewActionBarModel";

export const IT_VIEW_ACTION_BAR_CONTROLLER = new InjectionToken<IViewActionBarController>('IT_VIEW_ACTION_BAR_CONTROLLER');

export const MK_VIEW_ACTION_BAR = new ModelKey<ViewActionBarModel>('MK_VIEW_ACTION_BAR');

export interface IViewActionBarController extends IController {

}
